export type SortOrder = "asc" | "desc";

export const buildSortParam = (field: string, order: SortOrder) =>
  `${field},${order}`;

export const ITEM_SORT_FIELD_MAP: Record<string, string> = {
  title: "title",
  itemCode: "itemCode",
  itemNameCode: "title",
  category: "itemCategory",
};

export const PACKAGE_SORT_FIELD_MAP: Record<string, string> = {
  title: "title",
  packageCode: "packageCode",
  packageNameCode: "title",
};

export const SERVICE_SORT_FIELD_MAP: Record<string, string> = {
  title: "title",
  serviceCode: "serviceCode",
  serviceNameCode: "title",
};

export const ITEM_CATEGORY_SORT_FIELD_MAP: Record<string, string> = {
  title: "itemCategory",
  categoryCode: "categoryCode",
};

export const VEHICLE_SORT_FIELD_MAP: Record<string, string> = {
  lastServiceDate: "lastServiceDate",
};

export const getSortParamFromColumn = (
  columnId: string,
  order: SortOrder,
  fieldMap: Record<string, string>,
) => {
  const field = fieldMap[columnId];
  return field ? buildSortParam(field, order) : undefined;
};
